import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ListVendorPortalFailedRunsOutput } from '@erp/rpc';
import { orpc } from '@/api/rpc/client';

/** Recent Vendor Portal runs with Failed Accounts, and how many this user hasn't seen. */
export function useVendorPortalFailedRuns() {
  return useQuery(orpc.pricing.vendorPortals.listFailedRuns.queryOptions());
}

/**
 * Record that this user opened the failed-runs popover. Their badge clears at once; the
 * list is then refetched so it agrees with the server.
 */
export function useMarkVendorPortalFailedRunsSeen() {
  const queryClient = useQueryClient();
  const queryKey = orpc.pricing.vendorPortals.listFailedRuns.queryKey();
  return useMutation({
    ...orpc.pricing.vendorPortals.markFailedRunsSeen.mutationOptions(),
    onMutate: () => {
      queryClient.setQueryData<ListVendorPortalFailedRunsOutput>(
        queryKey,
        (current) => current && { ...current, unseenCount: 0 },
      );
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey }),
  });
}
